import React from "react"
import { Common } from "lib/types"
import { ReactComponent as CustomerIcon } from "images/icons/users.svg"

import { Customer } from "views/Customer/Customer"
import SearchCustomer from "views/Customer/SearchCustomer"
import { PermissionGroups } from "../constants"

export const customerRoutes: Common.Views = [
  {
    element: <Customer />,
    path: "/customer",
    title: "Customer",
    icon: CustomerIcon,
    sortOrder: 5,
    requiredGroups: PermissionGroups.customers.read,
    children: [
      {
        element: <SearchCustomer />,
        path: "/customer",
        title: "Store groups"
      }
    ]
  }
]
